import { render, staticRenderFns } from "./RollbackDrawer.vue?vue&type=template&id=572dec58&scoped=true"
import script from "./RollbackDrawer.vue?vue&type=script&lang=js"
export * from "./RollbackDrawer.vue?vue&type=script&lang=js"
import style0 from "./RollbackDrawer.vue?vue&type=style&index=0&id=572dec58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572dec58",
  null
  
)

export default component.exports